/**
 * Legacy combined-host redirects (RSW-336).
 * When users hit staging.rsworks.app, send them to the persona subdomain.
 */
import { normalizePathname } from './appSurfaceRoutes';
import { isCanonicalPortalPath } from './canonicalPaths';

/** Hostnames that served all personas before subdomain cutover. */
export const LEGACY_COMBINED_HOSTS = new Set([
  'staging.rsworks.app',
]);

const STAGING_PERSONA_HOSTS = {
  portal: 'https://portal.staging.rsworks.app',
  admin: 'https://admin.staging.rsworks.app',
  jobseeker: 'https://my.staging.rsworks.app',
};

/**
 * Resolve an absolute redirect URL for a legacy combined host, or null if not applicable.
 * @param {string} [hostname]
 * @param {string} [pathname]
 * @param {string} [search]
 * @param {string} [hash]
 * @returns {string|null}
 */
export function resolveLegacyHostRedirect(
  hostname = '',
  pathname = '/',
  search = '',
  hash = '',
) {
  if (!LEGACY_COMBINED_HOSTS.has(hostname)) return null;

  const path = normalizePathname(pathname);
  const suffix = `${search || ''}${hash || ''}`;

  const targetHost = path === '/admin' || path.startsWith('/admin/')
    ? STAGING_PERSONA_HOSTS.admin
    : path === '/counselor'
      || path.startsWith('/counselor/')
      || path === '/dashboard'
      || path.startsWith('/dashboard/')
      || path === '/'
      || isCanonicalPortalPath(path)
      ? STAGING_PERSONA_HOSTS.portal
      : STAGING_PERSONA_HOSTS.jobseeker;

  const targetPath = pathname && pathname !== '/' ? pathname : '/';
  return `${targetHost}${targetPath}${suffix}`;
}
